/**
 * ReportFinancialTemplate entity class
 */
import moment from 'moment/moment'

/**
 * ReportFinancialTemplateFactory
 * returns ReportFinancialTemplate entity class
 *
 * @class ReportFinancialTemplateFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ReportFinancialTemplate} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportFinancialTemplateFactory
 */
/* @ngInject */
export default function ReportFinancialTemplateFactory ($http, $injector, Entity, onOffMixin, alertLiteSvc) {
  /* === ReportFinancialTemplate class === */

  /**
   * ReportFinancialTemplate model
   *
   * @class ReportFinancialTemplate
   * @classdesc ReportFinancialTemplate model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @return {models.ReportFinancialTemplate} ReportFinancialTemplate entity
   */
  function ReportFinancialTemplate () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportFinancialTemplate.prototype = Object.create(Entity.prototype)
  ReportFinancialTemplate.prototype.constructor = ReportFinancialTemplate

  /* === User instance methods & fields === */

  Object.assign(ReportFinancialTemplate.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ReportFinancialTemplate#
     * @type {Object}
     */
    _fields: {
      createdBy: String,
      createdTime: moment,
      reportTemplateId: Number,
      name: String,
      organizations: [{ name: String, organizationId: Number }],
      reportTemplateDetails:
        {
          reportName: String,
          periodType: String,
          periodCount: Number,
          createdBy: String,
          purchaseItemCategories: [String],
          purchaseItemStatuses: [String],
          paymentSystemTypes: [String],
          paymentMethodTypes: [String],
          organizations: [{ name: String, organizationId: Number }],
          users: [],
          convertedAfterTrialDays: Number,
          firstActivation: Boolean,
          autoPay: Boolean,
          reportType: String,
          withoutTrial: Boolean,
          subscriptionsFilter: {
            dailySubscriptionLength: { from: Number, to: Number },
            monthlySubscriptionLength: { from: Number, to: Number },
            names: [String]
          }
        }
    },

    /**
     * url template
     *
     * @memberof models.ReportFinancial#
     * @type {String}
     */
    _urlTemplate: 'api/report/financial/template/{{::reportTemplateId}}',

    /**
     * public url template
     *
     * @memberof models.ReportFinancial#
     * @type {String}
     */
    _publicUrlTemplate: '/report/financial/template/{{::reportTemplateId}}',

    /**
     * Prepare
     *
     * @memberof models.ReportFinancial#
     * @override
     */
    _prepare: function () {
      this.reportDetails = this.reportTemplateDetails
    },

    /**
     * Generate template
     *
     * @private
     */
    _generate: function () {
      return $http.post(
        this._url,
        { templateId: this.id }
      ).catch(alertLiteSvc.alertError)
    }

  }, onOffMixin)

  /* === ReportFinancialTemplate static methods & fields === */

  ReportFinancialTemplate.getSubscriptions = function () {
    return $http.get('/report/financial/extra')
      .data()
      .then((response) => response.payload)
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  /**
   * Search shows by param
   *
   * @param {String} url
   * @param {Object} params
   * @returns {Promise} promise
   */
  ReportFinancialTemplate.search = function (url, params) {
    return $http.post(url, { ...params })
      .data()
      .then((response) => response.payload)
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  ReportFinancialTemplate.extra = {
    subscriptions: [{ id: Number, name: String }]
  }

  // copy all static methods from Entity class
  Object.assign(ReportFinancialTemplate, Entity)
  ReportFinancialTemplate._name = 'ReportFinancialTemplate'
  ReportFinancialTemplate.init()

  // permissions
  // ReportFinancialTemplate.access = {
  //   view: 'viewReport',
  //   create: 'createReport',
  //   delete: 'deleteReport'
  // }

  return ReportFinancialTemplate
}
